export default class AppInfo {
  constructor() {
    this.appEnvironment = process.env.VUE_APP_ENVIRONMENT;
    this.appVersion = process.env.VUE_APP_VERSION;
    this.projectName = process.env.VUE_APP_PROJECT_NAME;
    this.logLevel = process.env.VUE_APP_LOG_LEVEL;
    this.sentryDsn = process.env.VUE_APP_SENTRY_DSN;
  }
}
